<script setup lang="ts">
import UIKit from '@pocketprep/ui-kit'

const Banner = UIKit.Banner

const legacyBannerText = 'This assignment was created before we started supporting dates. '
    + 'Students can still access through the link, but can\'t see it in their app until dates are '
    + 'added. Edit assignment to add dates.'
</script>

<template>
    <Banner class="legacy-banner">
        {{ legacyBannerText }}
    </Banner>
</template>

<style lang="scss" scoped>
@use 'sass:color';

.legacy-banner {
    font-size: 15px;
    line-height: 19.5px;
    padding: 12px 24px 12px 16px;
    margin-bottom: 32px;
}
</style>
